import BaseProxy from './Proxy';

export default class UnbarringProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/unbarring', parameters);
  }

  init() {
    return this.submit('post', `${this.endpoint}/init`);
  }

  captchaReload() {
    return this.submit('get', `${this.endpoint}/captcha/reload`);
  }

  confirm({ captcha = null }) {
    return this.submit('post', `${this.endpoint}/confirm`, { captcha });
  }

  otpResend() {
    return this.submit('get', `${this.endpoint}/otp/resend`);
  }

  otpVerify(params) {
    return this.submit('post', `${this.endpoint}/otp/verify`, params);
  }

  pin(params) {
    return this.submit('post', `${this.endpoint}/pin`, params);
  }

  getRetryableErrorCodes() {
    return this.submit('get', `${this.endpoint}/retryableErrorCodes`);
  }

  getErrorParameters() {
    return this.submit('get', `${this.endpoint}/errorParameters`);
  }
}
